// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"0d2db50d","999":"36d8b4a5"}[chunkId] + ".chunk.js";
};